(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nivokid-cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('nk-cookie-panel');
  const reopen = document.getElementById('nk-cookie-reopen');
  if (!panel || !reopen || panel.dataset.bound) return;
  panel.dataset.bound = 'true';
  const options = document.getElementById('nk-cookie-options');
  const customize = document.getElementById('nk-cookie-customize');
  const error = document.getElementById('nk-cookie-error');
  const buttons = [...panel.querySelectorAll('button')];
  const keys = ['analytics', 'marketing', 'preferences'];
  let api;
  let busy = false;
  function show(focus) {
    panel.hidden = false;
    reopen.hidden = true;
    reopen.setAttribute('aria-expanded', 'true');
    if (api) {
      const consent = api.currentVisitorConsent();
      keys.forEach(key => { options.querySelector('[name="' + key + '"]').checked = consent[key] === 'yes'; });
    }
    if (focus) panel.querySelector('button').focus();
  }
  function hide() {
    const moveFocus = panel.contains(document.activeElement);
    panel.hidden = true;
    reopen.hidden = false;
    reopen.setAttribute('aria-expanded', 'false');
    if (moveFocus) reopen.focus();
  }
  function ready() {
    api = window.Shopify.customerPrivacy;
    const consent = api.currentVisitorConsent();
    if (keys.some(key => consent[key] !== 'yes' && consent[key] !== 'no')) show(false);
    else hide();
  }
  function load(attempt = 0) {
    if (window.Shopify?.customerPrivacy) { ready(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], failure => {
        if (failure) { show(false); error.hidden = false; return; }
        ready();
      });
    } else if (attempt < 30) setTimeout(() => load(attempt + 1), 200);
    else { show(false); error.hidden = false; }
  }
  reopen.addEventListener('click', () => show(true));
  customize.addEventListener('click', () => {
    options.hidden = !options.hidden;
    customize.setAttribute('aria-expanded', String(!options.hidden));
  });
  panel.addEventListener('click', event => {
    const button = event.target.closest('[data-nk-consent]');
    if (!button || busy) return;
    if (!api) { error.hidden = false; load(); return; }
    const mode = button.dataset.nkConsent;
    const consent = {};
    keys.forEach(key => {
      consent[key] = mode === 'save' ? options.querySelector('[name="' + key + '"]').checked : mode === 'accept';
    });
    consent.sale_of_data = false;
    busy = true;
    error.hidden = true;
    buttons.forEach(item => { item.disabled = true; });
    const reset = () => { busy = false; buttons.forEach(item => { item.disabled = false; }); };
    const timeout = setTimeout(() => { reset(); error.hidden = false; }, 10000);
    try {
      api.setTrackingConsent(consent, result => {
        clearTimeout(timeout);
        reset();
        if (result?.error) { error.hidden = false; return; }
        const saved = api.currentVisitorConsent();
        if (!keys.every(key => saved[key] === (consent[key] ? 'yes' : 'no'))) { error.hidden = false; return; }
        options.hidden = true;
        customize.setAttribute('aria-expanded', 'false');
        hide();
      });
    } catch (_) { clearTimeout(timeout); reset(); error.hidden = false; }
  });
  load();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nivokid-floating-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const link = document.querySelector('[data-nk-floating-cart]');
    if (!link) return;
    const count = link.querySelector('[data-nk-cart-count]');
    let pending = false;
    const refresh = async () => {
      if (pending || document.visibilityState === 'hidden') return;
      pending = true;
      try {
        const url = new URL(link.href);
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isInteger(cart.item_count) && cart.item_count >= 0) count.textContent = String(cart.item_count);
      } catch {} finally { pending = false; }
    };
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:change', refresh);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nivokid-new-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nk-gallery]').forEach(function(gallery) {
 gallery.querySelectorAll('[data-nk-photo]').forEach(function(button) {
  button.addEventListener('click',function() {
   const photo=gallery.querySelector(':scope > img');
   photo.src=button.dataset.nkPhoto;
   photo.alt=button.dataset.nkAlt;
   gallery.querySelectorAll('[data-nk-photo]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
  });
 });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nivokid-new-preview"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nk-preview-color]').forEach(function(select){
 function updatePhoto(){
  const option=select.options[select.selectedIndex];
  const photo=document.getElementById('nk-gallery-product-preview');
  if(photo){photo.src=option.dataset.photo;photo.alt=option.dataset.alt;}
  document.querySelectorAll('.nk-product-page [data-nk-photo]').forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.nkPhoto===option.dataset.photo));});
 }
 const index=new URL(window.location.href).searchParams.get('nk_color');
 if(index!==null && ['0','1','2'].includes(index)){select.value=index;}
 updatePhoto();
 select.addEventListener('change',updatePhoto);
 document.querySelectorAll('.nk-product-page [data-nk-photo]').forEach(function(button){button.addEventListener('click',function(){for(const option of select.options){if(option.dataset.photo===button.dataset.nkPhoto){select.value=option.value;break;}}});});
});
  } catch(e) { console.error(e); }
})();

})();
